import { render, staticRenderFns } from "./SocialDatePicker.vue?vue&type=template&id=059c1bd4&"
import script from "./SocialDatePicker.vue?vue&type=script&lang=js&"
export * from "./SocialDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059c1bd4')) {
      api.createRecord('059c1bd4', component.options)
    } else {
      api.reload('059c1bd4', component.options)
    }
    module.hot.accept("./SocialDatePicker.vue?vue&type=template&id=059c1bd4&", function () {
      api.rerender('059c1bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialDatePicker.vue"
export default component.exports